import React from 'react';
import { t } from 'Src/i18n';
import { LayerRentals } from 'Components/widgets/layer-rentals/LayerRentals';
type Props = PropsWithPageTracking<{
  forwardRef?: ReactRef;
  image?: string;
  layerName?: string;
  rentalsTree: RentalsTree;
  title?: string;
}>;
export const Rentals = ({ forwardRef, image, layerName, rentalsTree, title, tracking }: Props) => {
  if (!rentalsTree?.length) {
    return null;
  }

  const tle = title || t('common.rentals.title');
  const imageSrc = image || t('common.rentals.image');
  return (
    <LayerRentals
      forwardRef={forwardRef}
      image={imageSrc}
      layerName={layerName}
      rentalsTree={rentalsTree}
      title={tle}
      tracking={tracking}
    />
  );
};
